module.exports = __webpack_public_path__ + "img/reference-digisam.2f443d5e.webp";